import React, { Fragment } from 'react';
type Step = {
  id: number;
  name: string;
  component: React.ReactNode;
};
interface ProgressStepProps {
  currentStep: number;
  steps: Step[];
  onChange: (step: number) => void;
}
export function ProgressStep({
  currentStep,
  steps,
  onChange
}: ProgressStepProps) {
  return <div className="w-full" data-id="element-251">
      <h1 className="text-3xl font-bold mb-6" data-id="element-252">{steps[currentStep].name}</h1>
      <div className="hidden md:flex items-center w-full mb-8" data-id="element-253">
        {steps.map((step, index) => <Fragment key={step.id} data-id="element-254">
            <div className="flex flex-col items-center cursor-pointer" onClick={() => onChange(index)} data-id="element-255">
              <div className={`w-8 h-8 flex items-center justify-center rounded-full border-2 ${index < currentStep ? 'bg-blue-500 border-blue-500 text-white' : index === currentStep ? 'border-blue-500 text-blue-500' : 'border-gray-300 text-gray-300'}`} data-id="element-256">
                {index < currentStep ? '✓' : index + 1}
              </div>
              <span className={`mt-2 text-xs ${index <= currentStep ? 'text-blue-500 font-medium' : 'text-gray-500'}`} data-id="element-257">
                {step.name}
              </span>
            </div>
            {index < steps.length - 1 && <div className={`flex-1 h-0.5 mx-2 ${index < currentStep ? 'bg-blue-500' : 'bg-gray-300'}`} data-id="element-258" />}
          </Fragment>)}
      </div>
      <div className="text-sm text-gray-500 mb-4" data-id="element-259">
        Step {currentStep + 1} of {steps.length}
      </div>
    </div>;
}